import React, {Component} from 'react';
import ReactPlayer from 'react-player'
import {findDOMNode} from 'react-dom'
import screenfull from 'screenfull'
import './video.scss';
import {isIOS} from 'react-device-detect';

class VideoPlayerComponent extends Component {

    constructor(props, context) {
        super(props, context);

        // console.log('video props: ', this.props)
        this.watchedHeart = false;
        this.state = {
            url: this.props.src,
            pip: false,
            playing: false,
            controls: true,
            light: false,
            volume: 0.8,
            muted: false,
            played: 0,
            loaded: 0,
            duration: 0,
            playbackRate: 1.0,
            loop: false,
            autoPlay:true,

        }
        this.load = url => {
            this.setState({
                url,
                played: 0,
                loaded: 0,
                pip: false
            })
        }
    }
    componentDidMount(){
        this.checkPageSource();
    }

    checkPageSource(){
        if(this.props.tutorial){
            this.setState({
                autoPlay:false
            });
        }
    }

    playPause = () => {
        this.setState({playing: !this.state.playing})
    }
    stop = () => {
        this.setState({url: null, playing: false})
    }
    toggleControls = () => {
        const url = this.state.url
        this.setState({
            controls: !this.state.controls,
            url: null
        }, () => this.load(url))
    }
    toggleLight = () => {
        this.setState({light: !this.state.light})
    }
    toggleLoop = () => {
        this.setState({loop: !this.state.loop})
    }
    setVolume = e => {
        this.setState({volume: parseFloat(e.target.value)})
    }
    toggleMuted = () => {
        this.setState({muted: !this.state.muted})
    }
    setPlaybackRate = e => {
        this.setState({playbackRate: parseFloat(e.target.value)})
    }
    togglePIP = () => {
        this.setState({pip: !this.state.pip})
    }
    onPlay = () => {
        // console.log('onPlay')
        this.setState({playing: true})
    }
    onEnablePIP = () => {
        // console.log('onEnablePIP')
        this.setState({pip: true})
    }
    onDisablePIP = () => {
        // console.log('onDisablePIP')
        this.setState({pip: false})
    }
    onPause = () => {
        // console.log('onPause')
        this.setState({playing: false})
    }
    onSeekMouseDown = e => {
        this.setState({seeking: true});

    }
    onSeekChange = e => {
        this.setState({played: parseFloat(e.target.value)})
    }
    onSeekMouseUp = e => {
        this.setState({seeking: false})
        this.player.seekTo(parseFloat(e.target.value))
    }
    // listens to the player progress
    onProgress = state => {
        // console.log('check these props', this.props);
        // console.log('onProgress', state)
        // We only want to update time slider if we are not currently seeking
        if (this.state.played > .49) {
            if (!this.watchedHeart) {
                this.props.handleHeartFill();
                this.watchedHeart = true;
            }
        }
        if (!this.state.seeking) {
            this.setState(state)
        }
    }
    onEnded = () => {
        // console.log('onEnded')
        this.setState({playing: this.state.loop})
    }
    onDuration = (duration) => {
        // console.log('onDuration', duration)
        this.setState({duration})
    }
    onClickFullscreen = () => {
        screenfull.request(findDOMNode(this.player))
    }
    renderLoadButton = (url, label) => {
        return (
            <button onClick={() => this.load(url)}>
                {label}
            </button>
        )
    }

    ref = player => {
        this.player = player
    }


    render() {

        return (

            <div className='player-wrapper'>
                <ReactPlayer
                    ref={this.ref}
                    className='react-player'
                    width='100%'
                    height='100%'
                    url={this.state.url}
                    pip={this.state.pip}
                    playing={this.state.playing}
                    controls={this.state.controls}
                    light={this.state.light}
                    loop={this.state.loop}
                    playbackRate={this.state.playbackRate}
                    volume={this.state.volume}
                    muted={this.state.muted}
                    onReady={() => console.log('onReady')}
                    onStart={() => console.log('onStart')}
                    onPlay={this.onPlay}
                    onEnablePIP={this.onEnablePIP}
                    onDisablePIP={this.onDisablePIP}
                    onPause={this.onPause}
                    onBuffer={() => console.log('onBuffer')}
                    onSeek={e => console.log('onSeek', e)}
                    onEnded={this.onEnded}
                    onError={e => console.log('onError', e)}
                    onProgress={this.onProgress.bind(this)}
                    onDuration={this.onDuration}
                    config={
                        {
                            file: {
                                attributes:{
                                    autoPlay:this.state.autoPlay,
                                },
                                forceHLS: !isIOS,
                                forceVideo: true,
                                hlsVersion: '0.12.4',
                            }
                        }
                    }/>
            </div>
        )
    }
}

export default VideoPlayerComponent;
